import TextSearchResultItemSkeleton from '../skeletons/text-search-result-item'
import UserSearchResultItemSkeleton from '../skeletons/user-search-result-item-skeleton'

import FacelessBizSearchResultItemSkeleton from './faceless-biz-search-result-item-skeleton'

const SectionHeaderSkeleton = () => {
  return (
    <div className="flex items-center justify-between">
      <div className="h-5 w-32 animate-pulse rounded bg-gray-200" />
      <div className="h-4 w-14 animate-pulse rounded bg-gray-200" />
    </div>
  )
}

const SearchHistoryViewSkeleton = () => {
  return (
    <div className="z-10 flex min-h-[300px] flex-col gap-8">
      <div className="flex flex-col gap-3">
        <SectionHeaderSkeleton />
        <div className="flex flex-col gap-5">
          {Array.from({ length: 3 }).map((_, index) => (
            <TextSearchResultItemSkeleton key={`text-skeleton-${index}`} />
          ))}
        </div>
      </div>

      <div className="flex flex-col gap-3">
        <SectionHeaderSkeleton />
        <div className="flex flex-col gap-4">
          {Array.from({ length: 3 }).map((_, index) => (
            <FacelessBizSearchResultItemSkeleton key={`business-skeleton-${index}`} />
          ))}
        </div>
      </div>

      <div className="flex flex-col gap-3">
        <SectionHeaderSkeleton />
        <div className="flex flex-col gap-0">
          {Array.from({ length: 3 }).map((_, index) => (
            <UserSearchResultItemSkeleton key={`user-skeleton-${index}`} />
          ))}
        </div>
      </div>
    </div>
  )
}

export default SearchHistoryViewSkeleton
